<template>
  <div class="page_taskList">
    <div class="topNav">
      <div class="flex">
        <ShowNavHead />
        <div class="flex aic">
          <div class="flname">任务名称</div>
          <el-input size="small" v-model="listQuery.strTaskname" placeholder="" style="width: 200px;margin-left:5px;" clearable></el-input>
        </div>
        <div class="flex aic taskListTop">
          <div class="flname">采集平台</div>
          <el-select v-model="listQuery.strplatform" placeholder="" style="width: 200px;height: 32px;margin-left:5px;" filterable clearable>
            <el-option v-for="(item, index) in platformList" :key="index" :label="item.Strplatform" :value="item.Strplatform">
            </el-option>
          </el-select>
        </div>
        <div class="flex aic taskListTop">
          <div class="flname">任务状态</div>
          <el-select v-model="listQuery.strIsOpen" placeholder="" style="width: 90px;height: 32px;margin-left:5px;" clearable>
            <el-option label="开启" value="0"></el-option>
            <el-option label="关闭" value="1"></el-option>
          </el-select>
        </div>
        <div class="flex aic taskListTop">
          <div class="flname">采集分类</div>
          <el-select v-model="listQuery.strTaskType" placeholder="" style="width: 90px;height: 32px;margin-left:5px;" clearable>
            <el-option label="蓝领" value="1"></el-option>
            <el-option label="猎头" value="2"></el-option>
          </el-select>
        </div>
        <el-button type="success" size="small" @click="getTabData" style="margin-left:15px;height: 32px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs flex sb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>产品</el-breadcrumb-item>
        <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
        <el-breadcrumb-item>管理</el-breadcrumb-item>
        <el-breadcrumb-item>采集任务</el-breadcrumb-item>
      </el-breadcrumb>
      </div>
      <div class="task_box">
         <!-- @change="currChange($event)" -->
        <comTabs ref="child" :active="activeName"></comTabs>
        <div class="t_btn_box">
          <el-button type="success" size="small" @click="AddReportSet">+新建任务</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" v-loading="tableLoading" border>
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="StrTaskname" label="任务名称" :show-overflow-tooltip="true" min-width="100px" align="center">
          </el-table-column>
          <el-table-column prop="Strplatform" label="采集平台" :show-overflow-tooltip="true" min-width="100px" align="center">
          </el-table-column>
          <el-table-column prop="StrJobName" label="采集岗位" :show-overflow-tooltip="true" min-width="100px" align="center">
          </el-table-column>
          <el-table-column prop="Strcitycodename" label="采集地区" :show-overflow-tooltip="true" align="center" min-width="100px">
          </el-table-column>
          <el-table-column prop="DtTaskDate" label="采集开始时间" :show-overflow-tooltip="true" align="center" min-width="130px">
          </el-table-column>
          <el-table-column prop="Nexttime" label="下次执行时间" :show-overflow-tooltip="true" align="center" min-width="130px">
          </el-table-column>
          <el-table-column prop="RuningEndTime" label="最后执行时间" :show-overflow-tooltip="true" align="center" min-width="130px">
          </el-table-column>
          <el-table-column label="采集间隔" :show-overflow-tooltip="true" align="center" min-width="100px">
            <template slot-scope="{row}">
              <span>{{row.Strfreq+'天'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Strjoballcount" label="线索总量" :show-overflow-tooltip="true" align="center" min-width="100px">
          </el-table-column>
          <el-table-column label="采集分类" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.StrTaskType == 1">蓝领</span>
              <span v-if="row.StrTaskType == 2">猎头</span>
            </template>
          </el-table-column>
          <el-table-column label="运行状态" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.IsRuning == 1">正在运行</span>
              <span v-if="row.IsRuning == 0">空闲</span>
            </template>
          </el-table-column>
          <el-table-column prop="Msg" label="执行结果" :show-overflow-tooltip="true" align="center" min-width="130px">
            <template slot-scope="{row}">
              <span>{{row.Msg}}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" :show-overflow-tooltip="true" align="center" min-width="130px">
            <template slot-scope="{row}">
              <span>{{row.StrRemark}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100px" align="center" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <i class="el-icon-edit" style="font-size:20px;color: #19BD92;cursor: pointer;" @click="editTask(row)" title="编辑"></i>
              <i class="el-icon-delete" style="margin-left:25px;font-size:20px;color: #E6A23C;cursor: pointer;" @click="dltTask(row)" title="删除"></i>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="开关" width="80px" align="center">
            <template slot-scope="{row}">
              <el-switch v-model="row.StrIsOpen" active-value="0" inactive-value="1" active-color="#13ce66" inactive-color="#DCDFE6" :disabled="!isOver" @change="setTaskOpen($event,row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="changeBPage" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisibleSet" width="560px" :close-on-click-modal="false" class="t_dialog_box">
      <el-form :model="taskQuery" :rules="rules" ref="form" label-width="100px" class="demo-query">
        <el-form-item label="任务名称：" prop="StrTaskname">
          <el-input v-model="taskQuery.StrTaskname" size="small" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="采集平台：" prop="Strplatform">
          <el-select v-model="taskQuery.Strplatform" size="small" placeholder="" @change="platformChange" filterable clearable>
            <el-option v-for="(item, index) in platformList" :key="index+'d'" :label="item.Strplatform" :value="item.Strplatform">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集地区：">
          <el-select v-model="taskQuery.strcityArr" multiple size="small" placeholder="" @change="areaChange" filterable clearable>
            <el-option v-for="(item, index) in areaList" :key="index+'e'" :label="item.Strcitycodename" :value="item.Strcitycodename">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集岗位：" prop="StrJobName">
          <el-input v-model="taskQuery.StrJobName" size="small" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="采集间隔：" prop="Strfreq">
          <el-select v-model="taskQuery.Strfreq" size="small" placeholder="" clearable>
            <el-option label="1天" value="1"></el-option>
            <el-option label="2天" value="2"></el-option>
            <el-option label="3天" value="3"></el-option>
            <el-option label="5天" value="5"></el-option>
            <el-option label="7天" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集分类：" prop="StrTaskType">
          <el-select v-model="taskQuery.StrTaskType" size="small" placeholder="" clearable>
            <el-option label="蓝领" value="1"></el-option>
            <el-option label="猎头" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="定时时间：" prop="DtTaskDate">
          <el-time-picker v-model="taskQuery.DtTaskDate" size="small" :picker-options="{
            format: 'HH:mm'}" value-format="HH:mm" placeholder="" clearable>
          </el-time-picker>
        </el-form-item>
        <!-- <el-form-item label="任务开关：" prop="strIsOpen">
          <el-switch v-model="taskQuery.strIsOpen" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0">
          </el-switch>
        </el-form-item> -->
        <el-form-item label="备注：">
          <el-input v-model="taskQuery.StrRemark" size="small" type="textarea" :rows="2" placeholder="" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSet = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmAdd" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import comTabs from './components/comTab.vue'
  export default {
    components:{
      comTabs
    },
    data() {
      return {
        tableHeight: 0,
        tableData: [],
        activeName:'采集任务',
        tableLoading: false,
        listQuery: {
          currpage: 1,
          perpage: 10,
          strplatform: '',//平台
          strIsOpen: '0',//是否开启1 关闭 0开启
          strTaskType:'',//1蓝领2猎头
          strTaskname: ''// 任务名称
        },
        taskQuery: {
          Taskid: '',
          StrTaskname: '', //任务名称
          Strplatform: '', //平台
          StrJobName: '', //岗位名称
          DtTaskDate: '', //定时时间
          Strfreq:'',//频次
          StrRemark: '', //备注
          StrTaskType:'',//1蓝领  2猎头
          strcityArr:[],
          Strcitycodename:'',//城市名称
          Strcitycode:''//城市code
        },
        platformList: [], //平台列表
        total:0,
        isOver: true, //任务开关 是否操作完成
        rules: {
          StrTaskname: {
            required: true,
            message: '请输入任务名称',
            trigger: 'blur'
          },
          Strplatform: {
            required: true,
            message: '请选择采集平台',
            trigger: 'change'
          },
          StrJobName: {
            required: true,
            message: '请输入采集岗位',
            trigger: 'blur'
          },
          Strfreq: {
            required: true,
            message: '请选择采集间隔',
            trigger: 'change'
          },
          StrTaskType: {
            required: true,
            message: '请选择采集分类',
            trigger: 'change'
          }
        },
        dialogVisibleSet: false,
        dialogTitle:'新建任务',
        // 开启/关闭/删除 任务参数
        transQuery:{
          Taskid:'',
          StrIsOpen:'', //1 关闭 0 开启
          StrIsDel:'', //1 删除
          Strtype:'' //StrIsOpen 开启关闭 StrIsDel 删除
        },
        areaQuery:{
          bastype:''
        },
        areaList:[]//区域列表
      }
    },
    created() {
      this.calHeight();
      this.getTabData();
      this.getCollectionConfig();
    },
    methods: {
      // 子组件传值
      async currChange(value) {
        // console.log('currChange',value)
        this.activeName = value
        if(this.activeName == '区域配置'){
          this.$router.push({
            path: '/collectSet?active=区域配置'
          })
        }else if(this.activeName == '企业库'){
          this.$router.push({
            path: '/enterpriseLibrary?active=企业库'
          })
        }else if(this.activeName == '流程数据'){
          this.$router.push({
            path: '/processData?active=流程数据'
          })
        }
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //新增设置
      AddReportSet() {
        let that = this
        this.taskQuery = {
          Taskid: '',
          StrTaskname: '', //任务名称
          Strplatform: '', //平台
          StrJobName: '', //岗位名称
          DtTaskDate: '', //定时时间
          Strfreq:'',//频次
          StrRemark: '', //备注
          StrTaskType:'',//1蓝领  2猎头
          strcityArr:[],
          Strcitycodename:'',//城市名称
          Strcitycode:''//城市code
        };
        this.dialogTitle = '新增任务';
        this.dialogVisibleSet = true;
        // this.$nextTick(() => {
          // that.$refs['form'].resetFields();
        // });
      },
      // 编辑任务
      editTask(item){
        let that = this
        // console.log('ee',item)
        let platformVal = item.Strplatform
        if(!this.isNull(platformVal)){
          let obj = {};
          obj = that.platformList.find((item)=>{
              return item.Strplatform === platformVal;
          });
          this.areaQuery.bastype = obj.StrRuleName
          this.getAreaList()
        }else{
          this.areaQuery.bastype = ''
          this.areaList = []
        }
        this.taskQuery = {
          Taskid: this.isNull(item.Taskid)?'':item.Taskid,
          StrTaskname: item.StrTaskname, //任务名称
          Strplatform: item.Strplatform, //平台
          StrJobName: item.StrJobName, //岗位名称
          DtTaskDate: this.isNull(item.DtTaskDate)?'':item.DtTaskDate, //定时时间
          Strfreq:item.Strfreq,//频次
          StrRemark: item.StrRemark, //备注
          StrTaskType:this.isNull(item.StrTaskType)?'':item.StrTaskType,//1蓝领  2猎头
          strcityArr:this.isNull(item.Strcitycodename)?[]:item.Strcitycodename.split(','),
          Strcitycodename:this.isNull(item.Strcitycodename)?'':item.Strcitycodename,//城市名称
          Strcitycode:this.isNull(item.Strcitycode)?'':item.Strcitycode//城市code
        };
        this.dialogVisibleSet = true;
        this.dialogTitle = '编辑任务'
      },
      // 选择平台
      platformChange(val){
        this.taskQuery.Strcitycodename = ''
        this.taskQuery.Strcitycode = ''
        if(!this.isNull(val)){
          let obj = {};
          let that = this
          obj = that.platformList.find((item)=>{
              return item.Strplatform === val;
          });
          this.areaQuery.bastype = obj.StrRuleName
          this.getAreaList()
        }else{
          this.areaQuery.bastype = ''
          this.areaList = []
        }
      },
      // 选择采集地区
      areaChange(val){
        let obj = {};
        let that = this
        if(!this.isNull(val)){
          let valueListSelected = [];
          let labelListSelected = [];
          for(let i = 0; i < val.length; i++){
            that.areaList.find(item => {
              if(item.Strcitycodename == val[i]){
                valueListSelected.push(item.Strcitycode);
                labelListSelected.push(item.Strcitycodename);
              }
            })
          }
          // obj = that.areaList.find((item)=>{
          //     return item.Strcitycodename === val;
          // });
          that.taskQuery.Strcitycodename = labelListSelected.toString()
          that.taskQuery.Strcitycode = valueListSelected.toString()
          // console.log('22',that.taskQuery.Strcitycodename,that.taskQuery.Strcitycode)
        }else{
          that.taskQuery.Strcitycode = ''
          that.taskQuery.Strcitycodename = ''
        }
      },
      //获取平台列表
      getCollectionConfig() {
        let data = {
          currpage: 1,
          perpage: 100000
        }
        xz.getstrplatformList(data).then(res => {
          if (res.status == 'ok') {
            this.platformList = res.msg;
          } else {
            this.platformList = []
          }
        })
      },
      //获取城市区域列表
      getAreaList() {
        xz.gettaskcityList(this.areaQuery).then(res => {
          if (res.status == 'ok') {
            this.areaList = res.msg;
          } else {
            this.areaList = []
          }
        })
      },
      //获取任务列表
      getTabData() {
        this.tableLoading = true
        xz.gettaskList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.msg
            this.total = Number(res.totalcount)
          } else {
            this.tableData = []
            this.total = 0
          }
          this.tableLoading = false
        })
      },
      //确认新增任务
      confirmAdd() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // console.log(this.taskQuery)
            xz.savetaskinfo(this.taskQuery).then(res => {
              if (res.status == 'ok') {
                this.getTabData();
                this.$message.success('保存成功！')
              } else {
                this.$message.error('保存失败！')
              }
              this.dialogVisibleSet = false;
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //分页
      changeBPage(val) {
        this.listQuery.currpage = val;
        this.getTabData();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1;
        this.listQuery.perpage = val;
        this.getTabData();
      },
      //任务开关
      setTaskOpen($event,row) {
        let that = this;
        this.isOver = false;
        this.transQuery = {
          Taskid: row.Taskid,
          StrIsOpen: $event, //1 关闭 0 开启
          StrIsDel: '', //1 删除
          Strtype: 'StrIsOpen' //StrIsOpen 开启关闭 StrIsDel 删除
        }
        // console.log('pp',$event,this.transQuery)
        that.changeTask()
      },
      //任务删除
      dltTask(row) {
        let that = this
        this.transQuery = {
          Taskid: row.Taskid,
          StrIsOpen: row.StrIsOpen, //1 关闭 0 开启
          StrIsDel: '1', //1 删除
          Strtype: 'StrIsDel' //StrIsOpen 开启关闭 StrIsDel 删除
        }
        // console.log('ww',this.transQuery)
        this.$confirm('是否确定删除该任务?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res) => {
          that.changeTask()
        })
      },
      // 开启/关闭/删除 任务
      changeTask(){
        xz.uptaskinfo(this.transQuery).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！')
            this.getTabData();
          } else {
            this.$message.error('操作失败，请稍后再试！')
          }
          this.isOver = true;
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t_btn_box{
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  padding:0 10px 10px 0;
}
</style>
<style>
.page_taskList .el-table .el-table__cell{
  padding: 5px 0;
}
.t_dialog_box .el-select,
.t_dialog_box .el-form-item__content{
  width: 350px;
}
.t_dialog_box .el-dialog__body{
  padding: 10px 20px;
}
  .taskListTop .el-input__inner,
  .taskListTop .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>